import { render, staticRenderFns } from "./CreditInvoiceDetails.vue?vue&type=template&id=596a0ab4&scoped=true"
import script from "./CreditInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./CreditInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./CreditInvoiceDetails.vue?vue&type=style&index=0&id=596a0ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a0ab4",
  null
  
)

export default component.exports